/*eslint-disable no-magic-numbers */

const MEDIUM_TIMED_DELAY = 3000,
  ONE_MINUTE = 60000,
  ONE_HOUR = 60 * ONE_MINUTE,
  ONE_DAY = 24 * ONE_HOUR,
  SHORT_TIMED_DELAY = 1000,
  ONE_SECOND = 1000,
  FIVE_SECONDS = 5_000,
  THIRTY_SECONDS = 30_000,
  TEN_MINUTES = 600_000,
  TEN_SECONDS = 10_000,
  MILLISECOND_IN_SECOND = 1000,
  TO_SECOND_COEFFICIENT = 1 / MILLISECOND_IN_SECOND,
  MINI_DELAY = 50,
  SMALL_DELAY = 100;
export {
  FIVE_SECONDS,
  MEDIUM_TIMED_DELAY,
  MILLISECOND_IN_SECOND,
  MINI_DELAY,
  ONE_DAY,
  ONE_HOUR,
  ONE_MINUTE,
  ONE_SECOND,
  SHORT_TIMED_DELAY,
  SMALL_DELAY,
  TEN_MINUTES,
  TEN_SECONDS,
  THIRTY_SECONDS,
  TO_SECOND_COEFFICIENT,
};
